import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../../services/base.service';
import {Observable} from 'rxjs';
import {Campaign} from '../models/campaign';

@Injectable({
    providedIn: 'root'
})
export class CampaignService extends BaseService {

    httpOptions;

    constructor(private authService: AuthService, private httpClient: HttpClient) {
        super();

    }

    // get panels list
    public getCampaigns(): Observable<Campaign[]> {

        return this.httpClient.get<Campaign[]>(`${this.apiURL}/marketing/campaigns`, {
            headers: this.authService.getHttpOptions()
        });

    }

    public confirmSubscription(hash): Observable<any> {


        return this.httpClient.get<any>(`${this.apiURL}/marketing/campaign/subscription/conf/` + hash, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get panels list
    public getCampaignSubscribers(campaign_id): Observable<any> {

        return this.httpClient.get<any>(`${this.apiURL}/marketing/campaign/subscriptions/` + campaign_id, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get panels list
    public getWebsites(): Observable<any> {

        return this.httpClient.get<any>(`${this.apiURL}/mage/websites`, {
            headers: this.authService.getHttpOptions()
        });

    }

    // get panel by id
    public getCampaignByID(id): Observable<Campaign> {

        return this.httpClient.get<Campaign>(`${this.apiURL}/marketing/campaigns/` + id, {
            headers: this.authService.getHttpOptions()
        });

    }

    public loadCoupons() {

        return this.httpClient.get<any>(`${this.apiURL}/mage/coupons`, {
            headers: this.authService.getHttpOptions()
        });

    }


    // update panel
    public updateCampaign(campaign) {

        return this.httpClient.put<any>(`${this.apiURL}/marketing/campaigns`, campaign, {
            headers: this.authService.getHttpOptions()
        });

    }

    // create panel
    public createCampaign(campaign) {

        return this.httpClient.post<any>(`${this.apiURL}/marketing/campaigns`, campaign, {
            headers: this.authService.getHttpOptions()
        });

    }

    // create panel
    public subscribeCampaign(campaign_id, email,website_id) {

        let obj = {

            campaign_id: campaign_id,
            email: email,
            website_id: website_id

        }

        return this.httpClient.post<any>(`${this.apiURL}/marketing/campaign/subscribe`, obj, {
            headers: this.authService.getHttpOptions()
        });

    }

    // delete panel by id
    public removeCampaign(id): Observable<Campaign> {

        return this.httpClient.delete<Campaign>(`${this.apiURL}/marketing/campaigns/` + id, {
            headers: this.authService.getHttpOptions()
        });

    }


}
